var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Animated } from 'react-native';
import { useAnimateSpring, useAnimateTimming } from '../../hooks/useAnimate';
import usePrevious from '../../hooks/usePrevious';
import Icon from '../Icon';
export function useProgressAnimate(percentage, shouldAnimate) {
    const { animatedVal: trackActiveAnimateVal, runTiming: runActiveTiming } = useAnimateTimming({
        fromVal: shouldAnimate ? 0 : percentage,
        duration: 300,
        useNativeDriver: false,
    });
    const { animatedVal: trackInActiveAnimateVal, runTiming: runInActiveTiming, } = useAnimateTimming({
        fromVal: 100 - percentage,
        duration: 300,
        useNativeDriver: false,
    });
    // const {} = useAnimateTimming()
    useEffect(() => {
        if (!shouldAnimate)
            return;
        runActiveTiming(percentage);
        runInActiveTiming(100 - percentage);
    }, [percentage]);
    return {
        trackActiveAnimateVal,
        trackInActiveAnimateVal,
    };
}
export function useProgressIconAnimate({ percentage, fromVal = 1, toVal = 1.5, shouldAnimate, }) {
    const { animatedVal, runTiming } = useAnimateSpring({
        fromVal: fromVal,
    });
    function run() {
        return __awaiter(this, void 0, void 0, function* () {
            yield runTiming(toVal);
            runTiming(fromVal);
        });
    }
    useEffect(() => {
        if (!shouldAnimate)
            return;
        run();
    }, [percentage]);
    return {
        animatedVal,
    };
}
const grayIcon = 'https://g-static.ap4r.com/kos/s101/nlav11312/shop-c-h5/check_icon/check_gray2.png';
const redIcon = 'https://g-static.ap4r.com/kos/s101/nlav11312/shop-c-h5/check_icon/check_red2.png';
export function useMilestoneNodes(props) {
    const { milestone = [], percentage, milestoneIconSize = 12, milestoneAnimate = true, } = props || {};
    const previousPercentage = usePrevious(percentage);
    const { animatedVal: iconSizeAnimatedVal } = useProgressIconAnimate({
        percentage,
        shouldAnimate: !!(milestone === null || milestone === void 0 ? void 0 : milestone.length) && milestoneAnimate,
    });
    const milestoneNodes = milestone
        .map((v) => {
        if (typeof v === 'number') {
            return {
                percentage: v,
                node: (React.createElement(Icon, { uri: v <= percentage ? redIcon : grayIcon, customStyle: { iconSize: milestoneIconSize } })),
            };
        }
        else {
            return v;
        }
    })
        .map((v) => {
        const shouldScale = percentage > previousPercentage &&
            v.percentage > previousPercentage &&
            v.percentage <= percentage;
        return Object.assign(Object.assign({}, v), { node: (React.createElement(Animated.View, { key: v.percentage, style: [
                    {
                        position: 'absolute',
                        zIndex: 1,
                        left: `${v.percentage - 1}%`,
                    },
                    milestoneAnimate
                        ? {
                            transform: [
                                {
                                    scale: shouldScale
                                        ? iconSizeAnimatedVal
                                        : 1,
                                },
                            ],
                        }
                        : null,
                ] }, v.node)) });
    });
    return {
        milestoneNodes,
    };
}
